import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useInView } from 'react-intersection-observer'
import useMediaQuery from '@/hooks/use-media-query'
import { breakpoints, fontWeights, colors } from '@/styles'
import ApplicantInfo from '@/features/Application/applicant-info/applicant-info'
import { showCopyApplicationModal } from '@/components/copy-application-modal'

const tabletMinWidth = '1097px'

const InnerContentLeft = styled.div`
  position: relative;
  display: flex;
  height: 100%;
  align-items: flex-start;
  @media screen and (min-width: ${tabletMinWidth}) {
    max-width: 761px;
    border-right: 1px solid ${colors.grey88};
  }
  @media screen and (max-width: ${breakpoints.desktopSmall}) {
    max-width: 900px;
  }
`
const LeftContentWrapper = styled.div`
  width: 100%;
  @media screen and (min-width: ${tabletMinWidth}) {
    max-width: 285px;
    position: sticky;
    top: ${({ isSticky }) => (isSticky ? -360 : 0)}px;
    scroll-behavior: smooth;
    transition: top ease-in-out 0.1s;
    will-change: scroll-position;
  }
`

const LegendContainer = styled.div`
  margin: auto 24px auto 0;
  background-color: ${colors.white};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid ${colors.grey88};
  border-radius: 6px;
  height: auto;
  padding: 20px;
  @media screen and (max-width: ${breakpoints.dashboardMobile}) {
    margin-right: 30px;
  }
  @media screen and (max-width: ${breakpoints.desktopSmall}) {
    margin-right: 0;
    margin-top: 10px;
    border: none;
  }
`
const CreateContractContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: ${({ disableMargin }) => (disableMargin ? 'unset' : '20px 24px auto 0')};
  padding: 20px;
  background-color: ${colors.white};
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.06);
  border: 1px solid ${colors.grey88};
  border-radius: 6px;
  height: auto;
  gap: 15px;
`

const CreateContractTitle = styled.span`
  color: ${colors.black};
  font-weight: ${fontWeights.bold};
  font-size: 16px;
  line-height: 20px;
`

const LeftContentComponent = ({
  application,
  history,
  canCopyApplication,
  getContractButton,
  getContractButtonDescription,
  getMessageButton,
  buttonRef,
  applicationLoading
}) => {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.desktopSmall})`)
  const [profileScrollTop, setProfileScrollTop] = useState(0)
  const [isSticky, setIsSticky] = useState(false)

  const { ref: contractButtonRef, inView: contractButtonInView } = useInView({
    threshold: 1
  })

  useEffect(() => {
    const onScroll = e => {
      setProfileScrollTop(e.target.documentElement.scrollTop)
    }
    window.addEventListener('scroll', onScroll)
    if (profileScrollTop > 120) {
      setIsSticky(true)
    } else {
      setIsSticky(false)
    }

    return () => window.removeEventListener('scroll', onScroll)
  }, [profileScrollTop, contractButtonInView])

  return (
    <InnerContentLeft>
      <LeftContentWrapper isSticky={isSticky}>
        <LegendContainer>
          <ApplicantInfo
            handleCopyApplicant={
              canCopyApplication
                ? () =>
                    showCopyApplicationModal({
                      application,
                      history,
                      listingId: application.listing_id
                    })
                : null
            }
            applicationDate={application?.created_at}
            data={application?.user_info}
            timelineRoom={application?.timeline_room}
            getContractButton={getContractButton}
            isFavourite={application?.favourite === '1'}
            applicationId={application.id}
            applicationListingId={application.listing_id}
            buttonRef={buttonRef}
            application={application}
            applicationLoading={applicationLoading}
          />
        </LegendContainer>
        {!isMobile && (
          <>
            <CreateContractContainer ref={contractButtonRef}>
              <CreateContractTitle>{getContractButtonDescription()}</CreateContractTitle>
              {getContractButton()}
              {getMessageButton()}
            </CreateContractContainer>
          </>
        )}
      </LeftContentWrapper>
    </InnerContentLeft>
  )
}

export default LeftContentComponent
